/**
 * Builds display/download handlers for a document route outside deep React nesting (S2004).
 */
export function createDocumentRouteHandlers(rutaFisica, changePDFToDisplay, handleDownload) {
  return {
    displayPdf: () => changePDFToDisplay(rutaFisica),
    downloadPdf: () => handleDownload(rutaFisica),
  };
}
